export default "import { ALL_RESOURCES_LIST } from 'shared/constants';\n\nexport const useResources = () => {\n  return ALL_RESOURCES_LIST;\n}\n";